<template src="./DoctorsPending.html"></template>

<script>
import mixins from "../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      popupInfo: false,
      doctors: [],
      doctor: [],
      doctorTemp: [],
      specialties: [],
      files: [],
      isInvalidDoctor: true,
      currentx: 1,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
    };
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  watch: {
    currentx: function () {
      const vm = this;
      vm.changePagination();
    }
  },
  methods: {
    init() {
      const vm = this;
      vm.getDoctors();
    },
    downloadFile(file) {
      const vm = this;

      vm.axios
        .get(
          vm.$store.state.filooServer +
            "doctor/documents/" +
            file.id +
            "/download/" +
            file.name,
          {
            headers: { Authorization: vm.$session.get("bearer") },
            responseType: "arraybuffer"
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", file.name);
            document.body.appendChild(link);
            link.click();
          }
        });
    },
    approveDoctor(idDoctor) {
      const vm = this;

      vm.axios
        .put(
          vm.$store.state.filooServer +
            "admin/doctors/" +
            idDoctor +
            "/approve",
          vm.doctor,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            vm.$swal(
              "Sucesso",
              "O profissional <b style='color: #FF9F43; font-weight: 500'>" +
                vm.doctor.name +
              "</b> foi aprovado com sucesso!",
              "success"
            );
            vm.popupInfo = false;
            vm.getDoctors();
          }
        })
        .catch(function() {
          vm.$swal({
            title: "Acesso negado",
            text:
              "Ocorreu um erro para aprovar este profissional, tente novamente ou contate um administrador.",
            icon: "error"
          });
        });
    },
    disapproveDoctor(idDoctor) {
      const vm = this;

      vm.axios
        .put(
          vm.$store.state.filooServer +
            "admin/doctors/" +
            idDoctor +
            "/disapprove",
          {
            message:
              "Existem alguns documentos pendentes que você precisa enviar"
          },
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            vm.$swal(
              "Sucesso",
              "O profissional <b style='color: #FF9F43; font-weight: 500'>" +
                vm.doctor.name +
              "</b> foi reprovado com sucesso!",
              "success"
            );
            vm.popupInfo = false;
            vm.getDoctors();
          }
        })
        .catch(function() {
          vm.$swal({
            title: "Acesso negado",
            text:
              "Ocorreu um erro para reprovar este profissional, tente novamente ou contate um administrador.",
            icon: "error"
          });
        });
    },
    openPopUpInfo(idDoctor) {
      const vm = this;

      vm.axios
        .get(vm.$store.state.filooServer + "admin/doctors/" + idDoctor, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          vm.popupInfo = true;
          vm.doctor = response.data;

          let specialties = vm.doctor.specialties.filter(function(item) {
            return item.name;
          });
          vm.specialties = specialties;

          let files = vm.doctor.documents.filter(function(item) {
            return item;
          });
          vm.files = files;
          vm.isInvalidDoctor = vm.testNullUndefinedEmpty(vm.doctor.name)
            || vm.testNullUndefinedEmpty(vm.doctor.crmNumber)
            || vm.testNullUndefinedEmpty(vm.doctor.crmState)
            || vm.testNullUndefinedEmpty(vm.doctor.address)
            || !vm.validateEmail(vm.doctor.email);
        })
        .catch(function() {
          vm.$swal({
            title: "Acesso negado",
            text:
              "Ocorreu um erro para visualizar os detalhes deste profissional, tente novamente ou contate um administrador.",
            icon: "error"
          });
        });
    },
    getDoctors() {
      const vm = this;
      const page = vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/new-doctors?page=" + page + "&size=10&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.doctors = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.fillDoctors();
          }
        });
    },
    fillDoctors() {
      const vm = this;
      for (let d in vm.doctors) {
        if(vm.testNullUndefinedEmpty(vm.doctors[d].crmState) || vm.testNullUndefinedEmpty(vm.doctors[d].crmNumber)){
          vm.doctors[d].crm = "Não informado";
        } else {
          vm.doctors[d].crm =
          vm.doctors[d].crmState.toUpperCase() + " " + vm.doctors[d].crmNumber;
        }


        if (vm.doctors[d].phone == null || vm.doctors[d].phone == "") {
          vm.doctors[d].phoneFormat = "Não informado";
        } else if (vm.doctors[d].phone.length == 10) {
          vm.doctors[d].phoneFormat = vm.doctors[d].phone.replace(
            /(\d{2})(\d{4})(\d{4})/,
            "($1) $2-$3"
          );
        } else {
          vm.doctors[d].phoneFormat = vm.doctors[d].phone.replace(
            /(\d{2})(\d{5})(\d{4})/,
            "($1) $2-$3"
          );

        }
        let dateUs = vm.formatDateTwo(vm.doctors[d].create_date);
        vm.doctors[d].dateBr = vm.formatDateBr(dateUs);
      }
    },
    changePagination(){
      const vm = this;
      vm.getDoctors();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" src="./DoctorsPending.scss">
</style>
